import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlanoContasEmpresaInserirRoutingModule } from './plano-contas-empresa-inserir-routing.module';
import { PlanoContasEmpresaInserirComponent } from './plano-contas-empresa-inserir.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';


@NgModule({
  declarations: [
    PlanoContasEmpresaInserirComponent
  ],
  imports: [
    CommonModule,
    PlanoContasEmpresaInserirRoutingModule,
    FormsModule,
    TableModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    DividerModule,
    MessagesModule

  ]
})
export class PlanoContasEmpresaInserirModule { }
